// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Base-cls1__db42aa990b61c82776be{/*!*/}.Base-cls2__c62b318697c41f91a6b4{display:none}@media(min-width: 768px){.Base-cls2__c62b318697c41f91a6b4{display:flex;flex-direction:row;justify-content:space-between}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Base-cls1__db42aa990b61c82776be",
	"cls2": "Base-cls2__c62b318697c41f91a6b4 Base-cls1__db42aa990b61c82776be"
};
export default ___CSS_LOADER_EXPORT___;
